/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthCaseManagerRequest
 */
export interface UpdatePalReauthCaseManagerRequest {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    fax?: string | null;
    /**
     * 
     */
    email?: string | null;
}

/**
 * Check if a given object implements the UpdatePalReauthCaseManagerRequest interface.
 */
export function instanceOfUpdatePalReauthCaseManagerRequest(value: object): value is UpdatePalReauthCaseManagerRequest {
    return true;
}

export function UpdatePalReauthCaseManagerRequestFromJSON(json: any): UpdatePalReauthCaseManagerRequest {
    return UpdatePalReauthCaseManagerRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthCaseManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthCaseManagerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'fax': json['fax'] === undefined ? undefined : json['fax'] === null ? null : json['fax'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function UpdatePalReauthCaseManagerRequestToJSON(json: any): UpdatePalReauthCaseManagerRequest {
    return UpdatePalReauthCaseManagerRequestToJSONTyped(json, false);
}

export function UpdatePalReauthCaseManagerRequestToJSONTyped(value?: UpdatePalReauthCaseManagerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phone': value['phone'],
        'fax': value['fax'],
        'email': value['email'],
    };
}

